import './style.css';
import myImagen1 from './img/tranquilidad.jpeg';
import paso1 from './img/paso1-copia.png';
import hover_paso1 from './img/hover_paso1.png';
import paso2 from './img/paso2-copia.png';
import hover_paso2 from './img/hover_paso2.png';
import paso3 from './img/paso3-copia.png';
import hover_paso3 from './img/hover_paso3.png';
import { useState } from 'react';

export const SectionZero = () => {

    const [hover1, setHover1] = useState(false)
    const [hover2, setHover2] = useState(false)
    const [hover3, setHover3] = useState(false)

    const handlehover = (hover) =>{
        if (hover){
            hover = false
        }else {
            hover = true
        }
    }

	return (
        <section id="about">
            {/* <div className="container">
                <div className="titulo-pasos">
                    <h3>En solo <span>3 CÓMODOS PASOS</span></h3>
                </div>
                <div className="container-pasos">
                    <div className="paso">
                        <img src={paso1} alt="paso 1" />
                        <img className='hover-paso' src={hover_paso1} alt="paso 1" />
                    </div>
                    <div className="paso">
                        <img src={paso2} alt="paso 2" />
                        <img className='hover-paso' src={hover_paso2} alt="paso 2" />
                    </div>
                    <div className="paso">
                        <img src={paso3} alt="Paso 3" />
                        <img className='hover-paso' src={hover_paso3} alt="paso 3" />
                    </div>
                </div>
            </div>
            <div className="container my-5">
                <div className="titulo-pasos">
                    <h3>Servicios de cuidado personalizados, a <span>DOMICILIO</span> o en <span>CONSULTA</span>, adaptados a tus necesidades.</h3>
                </div>
            </div> */}
            <div className="container">
                <div className="titulo-pasos">
                    <p className='h3-about'>En solo <span>3 CÓMODOS PASOS</span></p>
                </div>
                <div className="d-flex flex-wrap res-titulos justify-content-center text-center">
                    <div className="paso p-3 mt-2">
                        <img className='res-img rounded-circle w-25' src={paso1} alt="paso 1" />
                        <div className="p-3">
                            <p className='w-100 h3-about pb-0'>BUSCA</p>
                            <p className='text-about fs-5'>Encuentra el servicio de cuidado ideal para tus necesidades.</p>
                        </div>
                        
                    </div>
                    <div className="paso p-3 mt-2">
                        <img className='res-img rounded-circle w-25' src={paso2} alt="paso 2"  onClick={()=>{hover2 ? setHover2(false) : setHover2(true)}} />
                        <div className="p-3">
                            <p className='w-100 h3-about pb-0'>ELIGE</p>
                            <p className='text-about fs-5'>Selecciona al profesional que mejor se ajuste a ti.</p>
                        </div>
                    </div>
                    <div className="paso p-3 mt-2">
                        <img className='res-img rounded-circle w-25' src={paso3} alt="Paso 3"  onClick={()=>{hover3 ? setHover3(false) : setHover3(true)}} />
                        <div className="p-3" >
                            <p className='w-100 h3-about pb-0'>RESERVA</p>
                            <p className='text-about fs-5'>Reserva fácilmente el día y la hora que prefieras.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container my-5">
                <div className="titulo-pasos">
                    <p className='h3-about'>Servicios de cuidado personalizados, a <span>DOMICILIO</span> o en <span>CONSULTA</span>, adaptados a tus necesidades.</p>
                </div>
            </div>
        </section>
        
	);
};
